import * as waitlist from "./waitlist";
import * as inference from "./inference";
import * as auth from "./auth";
import * as guestAuth from "./guestAuth";
import * as core from "./core";
import * as workspace from "./workspace";
import * as analytics from "./analytics";
import * as video from "./video";
import * as datasets from "./datasets";
import * as modelChanges from "./modelChanges";

export type Api = {
    auth: typeof auth;
    guestAuth: typeof guestAuth;
    core: typeof core;
    workspace: typeof workspace;
    waitlist: typeof waitlist;
    inference: typeof inference;
    analytics: typeof analytics;
    video: typeof video;
    datasets: typeof datasets;
    modelChanges: typeof modelChanges;
};

const api: Api = {
    auth,
    guestAuth,
    core,
    workspace,
    datasets,
    waitlist,
    inference,
    analytics,
    video,
    modelChanges
};

export default api;
